var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.85747 1.66663H17.1432C17.4588 1.66699 17.7614 1.79253 17.9846 2.01571C18.2078 2.23889 18.3333 2.54148 18.3337 2.8571V17.1428C18.3332 17.4584 18.2077 17.761 17.9845 17.9841C17.7613 18.2073 17.4588 18.3329 17.1432 18.3333H2.85747C2.54185 18.3329 2.23925 18.2074 2.01607 17.9842C1.7929 17.761 1.66735 17.4584 1.66699 17.1428V2.8571C1.66731 2.54147 1.79283 2.23885 2.01602 2.01566C2.23921 1.79247 2.54183 1.66694 2.85747 1.66663ZM8.80985 7.02377H17.1432V2.8571H8.80985V7.02377ZM7.61937 7.02377V2.8571H2.85747V7.02377H7.61937ZM2.85747 8.21425V17.1428H17.1444L17.1436 8.21425H2.85747ZM7.02415 15.9523C6.2351 15.9514 5.47863 15.6376 4.92069 15.0796C4.36275 14.5217 4.04889 13.7652 4.04796 12.9761H5.23843C5.23843 13.3293 5.34316 13.6746 5.53938 13.9682C5.7356 14.2619 6.01449 14.4908 6.34078 14.6259C6.66708 14.7611 7.02613 14.7965 7.37252 14.7276C7.71892 14.6586 8.0371 14.4886 8.28684 14.2388C8.53657 13.9891 8.70665 13.6709 8.77555 13.3245C8.84445 12.9781 8.80909 12.6191 8.67393 12.2928C8.53878 11.9665 8.3099 11.6876 8.01624 11.4914C7.72258 11.2952 7.37733 11.1904 7.02415 11.1904V9.99996C7.81348 9.99996 8.57049 10.3135 9.12863 10.8717C9.68678 11.4298 10.0003 12.1868 10.0003 12.9761C10.0003 13.7655 9.68678 14.5225 9.12863 15.0806C8.57049 15.6388 7.81348 15.9523 7.02415 15.9523ZM12.3813 9.99996H13.5718V15.9523H12.3813V9.99996ZM14.7622 12.9762H15.9527V15.9523H14.7622V12.9762Z",
    fill: "#E9EEF7"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/Dashboard.3ddf81e8e288f33263af3b0e8eb66564.svg";
export { ForwardRef as ReactComponent };